import React, { useState } from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';

// COMPONENTS
import { OrdersGrid } from '../../components/Orders';

const styles = theme => ({});

export const AllOrders = withStyles(styles)(props => {
  const { classes } = props;
  const [dialog, setDialog] = useState(false);

  return (
    <div className={classnames('flex-1', 'row-center-center', classes.gridContainer)}>
      <OrdersGrid setDialog={setDialog} />
    </div>
  );
});

AllOrders.propTypes = {};

AllOrders.defaultProps = {};
